import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { PreserveQueryParamsService } from '@api-ui-app/src/app/dashboard/services/preserve-query-params.service';

@Injectable({ providedIn: 'root' })
export class PreserveQueryParamsGuard implements CanActivate {
  constructor(private readonly preserveQueryParamsService: PreserveQueryParamsService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const queryParams = this.preserveQueryParamsService.getParams();

    if (queryParams) {
      this.router.navigate([''], { queryParams });
      this.preserveQueryParamsService.removeParams();
    }
    return of(true);
  }
}
